import { render, staticRenderFns } from "./specialTopic.vue?vue&type=template&id=175bc77a&scoped=true"
import script from "./specialTopic.vue?vue&type=script&lang=js"
export * from "./specialTopic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175bc77a",
  null
  
)

export default component.exports